module.exports = __webpack_public_path__ + "static/media/51.c6f054da.JPG";